b247.most_popular = function() {

  var element = $('[data-most-popular]');

  if (element.length) {

    element.each(function() {

      var target = $(this),
      list = target.find('[data-most-popular-list]'),
      items = target.find('[data-most-popular-item]');

      if (items.length > 5) {

        target.append('<p class="most-popular__more"><a href="#" class="button button--full" data-most-popular-more>View top 20</a></p>');

      }

    });

    $('[data-most-popular-more]').click(function() {

      $(this).closest('[data-most-popular]').addClass('most-popular--open');
      return false;

    });

  }

};
